import { Injectable } from "@angular/core";
import { SortDirection } from "@angular/material/sort";

export interface MerchantsListState {
    filter: string;
    pageIndex: number;
    pageSize: number;
    sortActive: string;
    sortDirection: SortDirection;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantsState {
    private state: MerchantsListState | null = null;

    saveState(state: MerchantsListState): void {
        this.state = { ...state };
    }

    getState(): MerchantsListState | null {
        const currentState = this.state;
        return currentState ? { ...currentState } : null;
    }

    resetState(): void {
        this.state = null;
    }
}